module.exports = __webpack_public_path__ + "static/media/cpanel.fba38cc2.svg";